<template>
  <header ref="header">
    <nav class="topbar">
      <router-link class="about" to="/about">
        <p>About Us</p>
      </router-link>
      <router-link class="logo" to="/">
        <p>SAHANI DECORS</p>
      </router-link>
      <router-link class="contact" to="/contact">
        <p>Contact</p>
      </router-link>
      <img class="burger" @click="releaseKraken" src="../assets/burger.svg" alt />
    </nav>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Navbar",
  computed: {
    ...mapGetters(["zbar_duck", "kraken"])
  },
  watch: {
    kraken: function(attack) {
      if (attack) this.$refs.header.classList.add("hide");
      else this.$refs.header.classList.remove("hide");
    },
    zbar_duck: function(value) {
      if (value) this.$refs.header.style.zIndex = 9;
      else this.$refs.header.style.zIndex = 22;
    }
  },
  methods: {
    releaseKraken: function() {
      this.$store.dispatch("kraken", true);
    }
  }
};
</script>

<style scoped lang="scss">
img {
  width: 1em;
  height: 1em;
}
header {
  position: relative;
  z-index: 22;
  width: 100%;
  background: $lightPrimary;
  transition: transform 1s ease;
  nav {
    width: 85vw;
    margin: auto;
    display: flex;
    justify-content: space-between;
    font-size: 1.3rem;
    padding: 1rem 0;
    text-align: center;

    .burger {
      display: none;
      width: 1em;
    }

    .logo {
      font-weight: 800;
      font-size: 1.2rem;
      @include mediumScreen {
        font-size: 1.5rem;
      }
    }

    @include smallScreen {
      width: 100%;
      font-size: 1.2rem;
      padding: 0.5rem 1rem;
      text-align: start;

      .contact,
      .about {
        display: none;
      }
      .burger {
        display: inline;
      }
    }
  }
}

.hide {
  transform: translateY(-100%);
}
</style>
